<template>
    <div class="wrapper">
        <v-layout>
            <v-main style="">
                <v-container style="text-align:left;padding:40px;font-size:14px;">

                    <v-row justify="left">
                        <v-col cols="12" md="12" lg="8" xl="8">
                            <h4 class="
                            text-h6
                            text-md-h6
                            text-lg-h5
                            text-xl-h5
                            text-truncate">
                                How to cite
                            </h4>

                            <div><b>Onkopus: Main publication</b></div>
                                <ul>
                                    <li>Kurz, N. S., Kornrumpf, K., Tucholski, T., Drofenik, K., König, A., Beißbarth, T., & Dönitz, J. (2025). Onkopus: precise interpretation and prioritization of sequence variants for biomedical research and precision medicine. Nucleic Acids Research, gkaf376.</li>
                                </ul>

                            <div><b>Related work</b></div>

                                <div>SeqCAT</div>
                                <ul>
                                    <li>Kornrumpf, K., Kurz, N. S., Drofenik, K., Krauß, L., Schneider, C., Koch, R., ... & Dönitz, J. (2024). Seqcat: Sequence conversion and analysis toolbox. Nucleic Acids Research, 52(W1), W116-W120.</li>
                                </ul>

                                <div>MTB-Report</div>
                                <ul>
                                    <li>Kurz, N. S., Perera-Bel, J., Höltermann, C., Tucholski, T., Yang, J., Beissbarth, T., & Dönitz, J. (2022). Identifying Actionable Variants in Cancer-The Dual Web and Batch Processing Tool MTB-Report. Studies in Health Technology and Informatics, 296, 73-80.</li>
                                </ul>
                        </v-col>
                    </v-row>

                    <v-row justify="left">
                        <v-col cols="12" md="12" lg="8" xl="8">
                            <h4 class="
                            text-h6
                            text-md-h6
                            text-lg-h5
                            text-xl-h5
                            text-truncate">
                                About us
                            </h4>
                            <p class="" style="margin-top:10px;">
                                Onkopus is developed and maintained by the Department of Medical Bioinformatics,
                                University Medical Center Göttingen (UMG), Germany. <br />
                                Please email us if you have any suggestions, want to report a bug, or want to discuss
                                our research. We appreciate all help and interest. <br /><br />
                                The Onkopus team: <br /><br/>

                                <v-card
                                    class="mx-auto"
                                    prepend-icon="mdi-account"
                                    subtitle=""
                                    title="Nadine S. Kurz"
                                  >
                                    <v-card-text>
                                        Department of Medical Bioinformatics<br/> University Medical Center Göttingen (UMG)<br />
                                        <a :href="`mailto:${nkemailAddress}`" v-html="obfuscateEmail(nkemailAddress)"></a>
                                    </v-card-text>
                                  </v-card>
                                  <v-card
                                    class="mx-auto"
                                    prepend-icon="mdi-account"
                                    subtitle=""
                                    title="Kevin Kornrumpf"
                                  >
                                  <v-card-text>Department of Medical Bioinformatics<br/> University Medical Center Göttingen (UMG)<br />
                                    </v-card-text>
                                  </v-card>
                                  <v-card
                                    class="mx-auto"
                                    prepend-icon="mdi-account"
                                    subtitle=""
                                    title="Tim Tucholski"
                                  >
                                  <v-card-text>Department of Medical Bioinformatics<br/> University Medical Center Göttingen (UMG)<br />
                                    </v-card-text>
                                  </v-card>
                                  <v-card
                                    class="mx-auto"
                                    prepend-icon="mdi-account"
                                    subtitle=""
                                    title="Klara Drofenik"
                                  >
                                  <v-card-text>Department of Medical Bioinformatics<br/> University Medical Center Göttingen (UMG)<br />
                                    </v-card-text>
                                  </v-card>
                                  <v-card
                                    class="mx-auto"
                                    prepend-icon="mdi-account"
                                    subtitle=""
                                    title="Tim Beißbarth"
                                  >
                                  <v-card-text>Department of Medical Bioinformatics<br/> University Medical Center Göttingen (UMG)<br />
                                    </v-card-text>
                                  </v-card>
                                  <v-card
                                    class="mx-auto"
                                    prepend-icon="mdi-account"
                                    subtitle=""
                                    title="Jürgen Dönitz"
                                  >
                                  <v-card-text>
                                            Department of Medical Bioinformatics<br/> University Medical Center Göttingen (UMG)<br />
                                            <a :href="`mailto:${jdemailAddress}`" v-html="obfuscateEmail(jdemailAddress)"></a>
                                    </v-card-text>
                                  </v-card>

                            </p>


                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="12" lg="8" xl="8">
                            <h4 class="
                            text-h6
                            text-md-h6
                            text-lg-h5
                            text-xl-h5
                            text-truncate">
                                Funders
                            </h4>

                            <v-row>
                                <v-col cols="12" md="12" lg="4" xl="4" style="margin-top:10px; margin-bottom:10px;">
                                    <a href="https://www.volkswagenstiftung.de/en">
                                        <img src="@/assets/logo-vwstiftung.svg" />
                                    </a>
                                </v-col>
                            </v-row>

                        </v-col>
                    </v-row>
                    <!--<v-row justify="left">
                        <v-col cols="12" md="12" lg="8" xl="8">
                            <h4 class="
                            text-h6
                            text-md-h6
                            text-lg-h5
                            text-xl-h5
                            text-truncate">
                                Terms of use
                            </h4>

                            The Onkopus modules and this web application are made available to the public under the CC BY 4.0 license.

                            Please cite Onkopus if you used Onkopus for your research: <br />

                            Kurz, Nadine Sina, et al. "Precise interpretation and prioritization of sequence variants with Onkopus for supporting molecular tumor boards." medRxiv (2024): 2024-09.

                        </v-col>
                    </v-row>-->

                </v-container>
            </v-main>
        </v-layout>
    </div>
</template>
<script>
export default {
    name: "ContactView",
    data: function () {
        return {
            nkemailAddress: 'nadine.kurz@bioinf.med.uni-goettingen.de',
            jdemailAddress: 'juergen.doenitz@bioinf.med.uni-goettingen.de'
        }
    },
    methods: {
        obfuscateEmail(email) {
          // Replace '@' with its HTML entity to prevent spam bots from scraping
          return email.replace('@', '&#64;')
        }
  }
}
</script>
<style>
.wrapper {
    background-color: #ffffff;
    color: #505050;
    width: 100%;
    height: 100%;
    /*background-image: url('@/assets/dna_v0.6.png');*/
    background-repeat: no-repeat;
    background-position: right center;
    background-size: cover;
}

.cryptedmail:after {
    content: attr(data-name) "@" attr(data-domain) "." attr(data-tld);
}
</style>
